import { useState } from 'react';
import { useIntl } from 'react-intl';
import DialogTitle from '@rossum/components/dialog-title/DialogTitle';
import { IconUserPlus } from '@rossum/ui/icons/tabler';
import { Button, Dialog, SvgIcon } from '@rossum/ui/material';
import { InviteColleagueContent } from './InviteColleagueContent';

const DIALOG_MAX_WIDTH = 448;

export const InviteColleague = () => {
  const [open, setOpen] = useState(false);

  const intl = useIntl();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        startIcon={
          <SvgIcon fontSize="large">
            <IconUserPlus />
          </SvgIcon>
        }
        onClick={() => setOpen(true)}
        variant="outlined"
        color="secondary"
        data-cy="invite-colleague-btn"
      >
        {intl.formatMessage({ id: 'components.inviteColleague.button' })}
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: { width: DIALOG_MAX_WIDTH, position: 'fixed' },
          elevation: 2,
        }}
      >
        {open && (
          <>
            <DialogTitle
              title={intl.formatMessage({
                id: 'components.inviteColleague.title',
              })}
              onClose={handleClose}
              closeDataCy="invite-colleague-close-icon"
            />
            {open && <InviteColleagueContent />}
          </>
        )}
      </Dialog>
    </>
  );
};
